<script>

    export let timeToCompleteMS = 2000; // time in milliseconds
    export let color = ""; // red, blue, green, <empty> for purple

    const Frequency = 50;
    const iterations = timeToCompleteMS / Frequency;
    const iterationSize = 100 / iterations;

    let progressValue = '0.0';
	let progressValuePercent = '0%';
    let level = 0;


    const progressInterval = setInterval( () => {
        level += iterationSize;
        progressValue = level / 100;
        progressValuePercent = level +'%';

    }, Frequency );

    const progressTimeOut = setTimeout( () => {
        clearInterval(progressInterval);
        clearTimeout(progressTimeOut);
    }, timeToCompleteMS );

</script>

<div
    id="stamina-bar"
    data-value="{progressValue}"
    class="rpgui-progress {color}"
    data-rpguitype="progress">
    <div class=" rpgui-progress-track">
    <div
        class=" rpgui-progress-fill {color}"
        style="left: 0px; width: {progressValuePercent};" />
    </div>
    <div class=" rpgui-progress-left-edge" />
    <div class=" rpgui-progress-right-edge" />
</div>